import { createElement, lazy } from 'react'
import moduleImport from '../libs/moduleImport'
import type { ComponentType, LazyExoticComponent } from 'react'

/**
 * Dynamic import ESM based web component by providing url and optional custom element tag name.
 * It will automatically wrap with React.lazy
 * @param url - ESM URL
 * @param tagName - optional tag name, if the default export provided the name, this can be ommited
 * @returns the React.lazy component of the exported value
 */
export const lazyImportWebComponent = <T extends ComponentType<any>>(url: string, tagName?: string): LazyExoticComponent<T> => (
  lazy<T>(() => moduleImport(url).then((module: { default?: string }) => {
    const comp = tagName || module.default
    if (!comp) {
      console.error(`failed to import web component from ${url}`)
      throw new Error('Failed to import web component')
    }
    const Comp = ((props: any) => createElement(comp, props)) as unknown as T
    return { default: Comp }
  }))
)
